// extracted by mini-css-extract-plugin
module.exports = {"link":"TrustpilotWidget_link__zvsyt","widget":"TrustpilotWidget_widget__e6a2E","logo":"TrustpilotWidget_logo__NQvP1","logo_dark":"TrustpilotWidget_logo_dark__n3WGp"};